import script from "./PersonnelDetailModal.vue?vue&type=script&setup=true&name=PersonnelDetailModal&lang=js"
export * from "./PersonnelDetailModal.vue?vue&type=script&setup=true&name=PersonnelDetailModal&lang=js"

import "./PersonnelDetailModal.vue?vue&type=style&index=0&id=99080284&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99080284"]])

export default __exports__